export const ERROR_CODE = {
  ERR_NETWORK: "ERR_NETWORK"
};

/**
 * `reason` values emitted by orbis-agentic-ai-service when an LLM-backed
 * stream fails. Sent on the SSE `stream:error` event and on error responses.
 */
export const LLM_ERROR_REASON = {
  /** Provider rejected the call — account credit/billing quota exhausted. */
  QUOTA_EXCEEDED: "ERR_LLM_QUOTA_EXCEEDED",
  /** Provider rejected the request (4xx) for a non-quota reason. */
  UNEXPECTED_ERROR: "ERR_LLM_UNEXPECTED_ERROR",
  /** Provider itself failed (5xx) and is temporarily unavailable. */
  PROVIDER_ERROR: "ERR_LLM_PROVIDER_ERROR"
} as const;

export type LlmErrorReason =
  (typeof LLM_ERROR_REASON)[keyof typeof LLM_ERROR_REASON];

export const STATUS_CODE = {
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  NOT_ACCEPTABLE: 406,
  REQUEST_TIMEOUT: 408,
  SESSION_TIMEOUT: 440,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503
};
